import { useEffect } from 'react';
import { Link } from 'react-router-dom';

import CancelIcon from 'assets/icons/base/cancel-icon.svg';
import Kassa24Logo from 'assets/images/kassa-mini-logo-black.svg';
import { PaymentStatus } from 'constants/payment';
import { useLoadData, usePaymentError, useTranslate, useYM } from 'hooks';
import { useAppSelector } from 'store/hooks';
import { useLazyRetryPaymentQuery } from 'store/payment/service';

import { BaseCard, Button } from '../ui';

const CheckError = () => {
  const { paymentData } = useAppSelector((state) => state.payment);
  const { trackOnClick } = useYM();
  const [retry, { isLoading }] = useLazyRetryPaymentQuery();
  const { loadData } = useLoadData();
  const { t } = useTranslate();
  const { getPaymentError } = usePaymentError();

  useEffect(() => {
    trackOnClick('errorMessage');
  }, [trackOnClick]);

  const handleRetryPayment = async () => {
    if (!paymentData) {
      return false;
    }

    try {
      await retry(paymentData.ID).unwrap();

      await loadData();

      return true;
    } catch {
      return false;
    }
  };

  return (
    <BaseCard>
      <div className="bg-white md:bg-base-gray-100 flex-grow w-full h-full md:rounded-large col-start-1 col-end-3 flex flex-col justify-center items-center text-center gap-8 p-8">
        <div className="flex flex-col gap-8 max-w-[330px] items-center justify-center flex-grow">
          <img src={CancelIcon} alt="logo" />

          {paymentData?.ID && (
            <dl className="text-sm leading-5">
              <dt>{t('lang.order')}</dt>
              <dd className="font-bold">{paymentData.ID}</dd>
            </dl>
          )}

          <dl className="text-sm leading-5">
            <dt className="text-base leading-6 font-bold mb-2">
              {getPaymentError(paymentData?.error)}
            </dt>

            <dd className="check-error__info-description">
              {t('lang.if_error_repeats_contact_store_2')}
            </dd>
          </dl>
          {paymentData?.status === PaymentStatus.RETRYABLE_FAILED && (
            <Button isLoading={isLoading} onClick={handleRetryPayment}>
              {t('repeat_payment')}
            </Button>
          )}
        </div>
        <div className="block md:hidden">
          <Link to="/">
            <img src={Kassa24Logo} alt="kassa24" />
          </Link>
        </div>
      </div>
    </BaseCard>
  );
};

export { CheckError };
